import { render, staticRenderFns } from "./QuickStatsSection.vue?vue&type=template&id=71b2c5c8&scoped=true&"
import script from "./QuickStatsSection.vue?vue&type=script&lang=js&"
export * from "./QuickStatsSection.vue?vue&type=script&lang=js&"
import style0 from "./QuickStatsSection.vue?vue&type=style&index=0&id=71b2c5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2c5c8",
  null
  
)

export default component.exports